<template>
  <div class="saved-card">
    <slot/>
    <div class="row">
      <div class="col-sm-8">
        <div class="card-row">
          <img class="credit-card" src="/static/images/creditcards/visa.svg">
          <img class="credit-card" src="/static/images/creditcards/mastercard.svg">
          <img class="credit-card" src="/static/images/creditcards/amex.svg">
          <img class="credit-card" src="/static/images/creditcards/discover.svg">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-9">
        <div class="form-group">
          <div class="required">
            <input v-model="value.name" id="name" type="text" class="form-control" placeholder="Name on Card" v-validate="'required'" required/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-9">
        <div class="form-group">
          <div class="required">
            <div class="input-group">
              <input v-model="value.card_number" id="card_number" type="text" class="form-control" placeholder="Credit Card Number" v-validate="'required|credit_card'" required/>
              <span class="input-group-addon">
                <svg class="icon icon-lock"><use xlink:href="#icon-lock"></use></svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-md-4">
        <div class="form-group">
          <div class="required">
            <input type="text"
              v-model="value.expiration"
              @blur="fixExpiration"
              id="expiration"
              class="form-control"
              placeholder="MM/YY"
              v-validate="'required|date_format:MM/YY'"
              required>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <div class="required">
            <!--validate 3-4 digits https://stackoverflow.com/questions/13178912/regex-for-matching-certain-numbers-of-digits-->
            <input type="text" v-model="value.cvc" id="cvc" class="form-control" placeholder="CVC" data-stripe="cvc" v-validate="{ required: true, regex: /^\d{3}(\d{1})?$/ }" required>
          </div>
        </div>
      </div>
      <a target="_blank" href="https://ssl.comodo.com/wildcard-ssl-certificates.php" class="secure">
      <img src="/static/images/creditcards/comodo-seal.svg" alt="Comodo Trusted Site Seal" width="auto" height="40" style="border: 0px;"></a><br>
    </div>

    <div class="row">
      <div class="col-sm-9">
        <b-form-group class="row compact" label="Saved Card Options:" label-for="title">
          <div class="required">
            <input v-model="value.title" id="title" type="text" class="form-control" placeholder="Description of card" v-validate="'required'" required/>
          </div>
          <PrivateToggle v-model="is_private" noun="card" />
        </b-form-group>
      </div>
    </div>

    <section>
      <h2>Billing Address</h2>
      <b-form-group class="row compact" label="Address:" label-for="line1" v-bind="validationAttrsFor('line1')">
        <b-form-input v-validate="'required'" name="line1" v-model="value.line1" id="line1" data-vv-as="address line 1" placeholder="Enter address"/>
      </b-form-group>
      <b-form-group class="row compact" label="Address:" label-for="line2" v-bind="validationAttrsFor('line2')">
        <b-form-input v-model="value.line2" name="line2" id="line2" placeholder="Enter line 2"/>
      </b-form-group>
      <b-row>
        <b-col sm=6>
          <b-form-group class="compact" label="City:" label-for="city" v-bind="validationAttrsFor('city')">
            <b-form-input v-validate="'required'" v-model="value.city" name="city" id="city" placeholder="Enter city"/>
          </b-form-group>
        </b-col>
        <b-col sm=3>
          <b-form-group class="compact" label="State:" label-for="state" v-bind="validationAttrsFor('state')">
            <b-form-input v-validate="'required'" v-model="value.state" name="state" id="state" placeholder="Enter state"/>
          </b-form-group>
        </b-col>
        <b-col sm=3>
          <b-form-group class="compact" label="Zip:" label-for="postcode" v-bind="validationAttrsFor('postcode')">
            <b-form-input v-validate="'required'" v-model="value.postcode" name="postcode" id="postcode" placeholder="Enter postcode"/>
          </b-form-group>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<style scoped lang="scss">
section {
  margin-top: 1em;
}

.card-row {
  display:flex;
  margin-bottom: 16px;
  margin-right: 3px;
  background-repeat: no-repeat;
  background-size: contain;

& .credit-card{
  width: 48px;
  height: 30px;
}
}

fieldset.compact {
  height:100%;
  margin: 0;
  padding: 0;
  border: none;
}

.input-group-addon{
  border: 1px solid rgba(0,0,0,.15);
  border-top-right-radius:.25rem !important;
  border-bottom-right-radius:.25rem !important;
}

 @media (max-width: 576px) {
   .saved-card{
     padding-bottom: 80px;
   }
   .secure{
     margin: 0 0 1em 1em;
   }
  }
</style>

<script>
export default {
  props: ['value'],
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  },
  computed: {
    is_private: {
      get() { return !this.value.available_to_team; },
      set(value) { this.value.available_to_team = !value; }
    }
  },
  methods: {
    fixExpiration() {
      this.value.expiration = this.value.expiration.replace(/^(\d\d)(\d\d)$/, "$1/$2");
    },
    validationAttrsFor(fieldname) {
      let feedback, state;
      let err = this.errors.first(fieldname);
      feedback = err;
      state = !err;  // TODO maybe return null when v-validate "untouched" flag or similar
      return { state, 'invalid-feedback': feedback };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/billing/NewSavedCard.vue